import { LegalDoc } from "@frontend/components/site/legal-doc";
import { PRIVACY_META, PRIVACY_SECTIONS } from "@frontend/components/site/legal-data";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";

export function PrivacyPage() {
  return (
    <main>
      <Seo title={PRIVACY_META.title} description={PRIVACY_META.description} path={PRIVACY_META.path} />
      <LegalDoc
        eyebrow="Legal"
        title="Privacy Policy"
        updated={PRIVACY_META.updated}
        intro={`How ${branding.name} collects, uses, and shares personal data when you use the website and apps.`}
        sections={PRIVACY_SECTIONS}
      />
    </main>
  );
}
